// src/pages/WhoopOAuthCallback.tsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function WhoopOAuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/settings?whoop=connected");
  }, []);

  return (
    <div className="h-screen flex items-center justify-center bg-[#ffffff] text-[#0f172a]">
      Connecting your WHOOP account…
    </div>
  );
}
